"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
require("antd/lib/select/style");
var _select = _interopRequireDefault(require("antd/lib/select"));
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _DatePicker = require("../../DatePicker");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var FormItem = _form.default.Item;
var Option = _select.default.Option;
var LicenseForm = function LicenseForm(_ref) {
  var _ref$license = _ref.license,
    license = _ref$license === void 0 ? {} : _ref$license,
    states = _ref.states,
    getFieldDecorator = _ref.getFieldDecorator,
    index = _ref.index;
  var names = {
    licenseName: index ? "licenses[".concat(index, "].licenseName") : 'licenseName',
    licenseType: index ? "licenses[".concat(index, "].licenseType") : 'licenseType',
    licenseNumber: index ? "licenses[".concat(index, "].licenseNumber") : 'licenseNumber',
    state: index ? "licenses[".concat(index, "].state") : 'state',
    expirationDate: index ? "licenses[".concat(index, "].expirationDate") : 'expirationDate'
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator(names.licenseName, {
    initialValue: license.licenseName,
    rules: [{
      required: true,
      message: 'Please enter license name'
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "License name",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    span: 11
  }, /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator(names.licenseType, {
    initialValue: license.licenseType,
    rules: [{
      required: true,
      message: 'Please enter license type'
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Type",
    size: "large"
  })))), /*#__PURE__*/_react.default.createElement(_col.default, {
    span: 11,
    offset: 2
  }, /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator(names.licenseNumber, {
    initialValue: license.licenseNumber,
    rules: [{
      required: true,
      message: 'Please enter license number'
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Numbers",
    size: "large"
  }))))), /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator(names.state, {
    initialValue: license.state,
    rules: [{
      required: true,
      message: 'Please enter state'
    }]
  })( /*#__PURE__*/_react.default.createElement(_select.default, {
    filterOption: function filterOption(input, option) {
      return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    optionFilterProp: "children",
    placeholder: "State",
    showSearch: true
  }, states.map(function (_ref2) {
    var abbreviation = _ref2.abbreviation,
      name = _ref2.name;
    return /*#__PURE__*/_react.default.createElement(Option, {
      key: abbreviation,
      value: abbreviation
    }, name);
  })))), /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label material-form-item"
  }, getFieldDecorator(names.expirationDate, {
    initialValue: license.expirationDate ? _momentTimezone.default.utc(license.expirationDate) : null
  })( /*#__PURE__*/_react.default.createElement(_DatePicker.DatePicker, {
    placeholder: "MM/DD/YYYY",
    size: "large"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "ant-input-group-addon permanent-open"
  }, "Expiration Date")));
};
LicenseForm.propTypes = {
  states: _propTypes.default.array
};
var _default = _form.default.create({
  name: 'LicenseForm'
})(LicenseForm);
exports.default = _default;